export const title = [
  {
    title: 'S. No',
    width: { wch: 10 },
    padding: { ppx: 100 },
    style: {
      fill: { patternType: 'solid', fgColor: { rgb: 'FFFF0000' } },
    },
  },
  { title: 'Role', width: { wch: 70 }, padding: { ppx: 100 } },
  {
    title: 'Application Last Date',
  },
  { title: 'Number of Colleges', width: { wch: 40 }, padding: { ppx: 100 } },
  { title: 'Colleges Accepted', width: { wch: 30 } },
  { title: 'Colleges Pending', width: { wch: 45 } },
  { title: 'Colleges Rejected', width: { wch: 20 } },
]
export const CandidateApplicationTitle = [
  { title: 'S. No', width: { wch: 10 }, padding: { ppx: 100 } },
  { title: 'Role', width: { wch: 70 }, padding: { ppx: 100 } },
  { title: 'No. of Drives', width: { wch: 10 }, padding: { ppx: 100 } },
  { title: 'Application Last Date', width: { wch: 10 }, padding: { ppx: 100 } },
  { title: 'College Name', width: { wch: 10 }, padding: { ppx: 100 } },
  { title: 'Tier', width: { wch: 10 }, padding: { ppx: 100 } },
  { title: 'Students Applied', width: { wch: 10 }, padding: { ppx: 100 } },
  { title: 'Avg Student Ranking', width: { wch: 10 }, padding: { ppx: 100 } },
  { title: 'Offer Made', width: { wch: 10 }, padding: { ppx: 100 } },
  { title: 'Offer Accepted', width: { wch: 10 }, padding: { ppx: 100 } },
]

export const yesNo = [
  {
    name: 'Yes',
    value: '1',
  },
  {
    name: 'No',
    value: '0',
  },
]
export const ApplicationDriveTitle = [
  { title: 'S. No', width: { wch: 10 }, padding: { ppx: 100 } },
  { title: 'Drive Date', width: { wch: 10 }, padding: { ppx: 100 } },
  { title: 'Student Name', width: { wch: 10 }, padding: { ppx: 100 } },
  { title: 'College Name', width: { wch: 10 }, padding: { ppx: 100 } },
  { title: 'Degree', width: { wch: 10 }, padding: { ppx: 100 } },
  { title: 'Tier', width: { wch: 10 }, padding: { ppx: 100 } },
  { title: 'Drive Number', width: { wch: 10 }, padding: { ppx: 100 } },
  { title: 'Role', width: { wch: 10 }, padding: { ppx: 100 } },
  { title: 'Rank', width: { wch: 10 }, padding: { ppx: 100 } },
  { title: 'Round', width: { wch: 10 }, padding: { ppx: 100 } },
  { title: 'Status', width: { wch: 10 }, padding: { ppx: 100 } },
]
export const HiringLevelTitle = [
  { title: 'S. No', width: { wch: 10 }, padding: { ppx: 100 } },
  { title: 'Role', width: { wch: 10 }, padding: { ppx: 100 } },
  { title: 'Role Posted', width: { wch: 10 }, padding: { ppx: 100 } },
  { title: ' Date of app', width: { wch: 10 }, padding: { ppx: 100 } },
  { title: 'Candidate Name', width: { wch: 10 }, padding: { ppx: 100 } },
  { title: 'Exp. level', width: { wch: 10 }, padding: { ppx: 100 } },
  { title: 'Degree', width: { wch: 10 }, padding: { ppx: 100 } },
  { title: 'Department', width: { wch: 10 }, padding: { ppx: 100 } },
  { title: 'Primary Skills', width: { wch: 10 }, padding: { ppx: 100 } },
  { title: 'Off. Date', width: { wch: 10 }, padding: { ppx: 100 } },
  { title: 'Joining Date', width: { wch: 10 }, padding: { ppx: 100 } },
  { title: 'Joining Location', width: { wch: 10 }, padding: { ppx: 100 } },
]

export const InterviewScheduleTitle = [
  { title: 'S. No', width: { wch: 10 }, padding: { ppx: 100 } },
  { title: 'Drive', width: { wch: 10 }, padding: { ppx: 100 } },
  { title: 'Drive Type', width: { wch: 10 }, padding: { ppx: 100 } },
  { title: 'Interviewer Name', width: { wch: 10 }, padding: { ppx: 100 } },
  { title: 'Candidate Name', width: { wch: 10 }, padding: { ppx: 100 } },
  { title: 'Exp. level', width: { wch: 10 }, padding: { ppx: 100 } },
  { title: 'Degree', width: { wch: 10 }, padding: { ppx: 100 } },
  { title: 'Department', width: { wch: 10 }, padding: { ppx: 100 } },
  { title: 'Primary Skills', width: { wch: 10 }, padding: { ppx: 100 } },
  { title: 'Student Rank', width: { wch: 10 }, padding: { ppx: 100 } },
]
export const OptionData = [
  {
    name: '>',
  },
  {
    name: 'divider',
  },
  {
    name: '<',
  },
  {
    name: 'divider',
  },
  {
    name: '=',
  },
  {
    name: 'divider',
  },
  {
    name: '<=',
  },
  {
    name: 'divider',
  },
  {
    name: '>=',
  },
]

export const RoleTitle = [
  {
    title: 'Plants',
    width: { wch: 50 },
    padding: { ppx: 100 },
    alignment: { horizontal: 'center' },
    fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFF00' } },
  },
  { title: '', width: { wch: 10 } },
  { title: '', width: { wch: 10 } },
  { title: '', width: { wch: 10 } },
  { title: 'Plants', width: { wch: 10 } }, // Merge 3 cells horizontally
  { title: 'Animals', width: { wch: 20 } }, // Merge 3 cells horizontally
  { title: 'Total', width: { wch: 20 } }, // Merge 3 cells horizontally
]
